export interface Integration {
    id: string;
    name: string;
    type?: string;
    image: string;
    slug: string;
}

export const integrations: Integration[] = [
    {
        id: '1',
        name: 'Milvus',
        type: 'vector-database',
        image: '/configuration/milvus.png',
        slug: 'milvus',
    },
    {
        id: '2',
        name: 'Elasticsearch',
        type: 'search-engine',
        image: '/configuration/elasticsearch.png',
        slug: 'elasticsearch'
    },
    {
        id: '3',
        name: 'Redis',
        type: 'database',
        image: '/configuration/redis.png',
        slug: 'redis'
    },
    {
        id: '4',
        name: 'Outlook',
        type: 'Email',
        image: '/configuration/outlook.webp',
        slug: 'outlook'
    },
    {
        id: '5',
        name: 'IBM Watson',
        type: 'AI Service',
        image: '/configuration/watson.jpeg',
        slug: 'ibm-watson'
    },
];
